import React, { Component } from "react";
import { Button, Card, CardTitle, CardBody, Progress } from "reactstrap";
import { connect } from "react-redux";

import { PROF_VOTE_REQUESTED } from "../../actions.js";

class ProfCard extends Component {
  render() {
    const total = this.props.professor.upvotes + this.props.professor.downvotes;
    const success = this.props.professor.upvotes * 100 / total;
    const danger = this.props.professor.downvotes * 100 / total;

    const vote = this.props.professorVotes[this.props.professor.id];
    const canUpvote = vote === undefined || !vote;
    const canDownvote = vote === undefined || vote;
    return (
      <Card className="prof-card padded">
        <Progress multi>
          <Progress bar color="success" value={success} />
          <Progress bar color="danger" value={danger} />
        </Progress>
        <CardBody>
          <CardTitle>
            Prof. {this.props.professor.firstName}{" "}
            {this.props.professor.lastName}
            <div className="score">
              <Button
                className="vote-btn"
                size="sm"
                color="success"
                disabled={!canUpvote}
                onClick={() => this.props.onUpvote(this.props.professor)}
              >
                <i className="fa fa-thumbs-up" aria-hidden="true" />
                {" " + this.props.professor.upvotes}
              </Button>
              <Button
                className="vote-btn"
                size="sm"
                color="danger"
                disabled={!canDownvote}
                onClick={() => this.props.onDownvote(this.props.professor)}
              >
                <i className="fa fa-thumbs-down" aria-hidden="true" />
                {" " + this.props.professor.downvotes}
              </Button>
              <span className="font-weight-bold">
                {this.props.professor.upvotes - this.props.professor.downvotes}
              </span>
            </div>
          </CardTitle>
        </CardBody>
      </Card>
    );
  }
}

const mapStateToProps = state => state;

const mapDispatchToProps = dispatch => {
  return {
    onUpvote: professor => {
      dispatch({
        type: PROF_VOTE_REQUESTED,
        professor: professor,
        upvote: true
      });
    },
    onDownvote: professor => {
      dispatch({
        type: PROF_VOTE_REQUESTED,
        professor: professor,
        upvote: false
      });
    }
  };
};

const ProfCardContainer = connect(mapStateToProps, mapDispatchToProps)(
  ProfCard
);

export default ProfCardContainer;



// WEBPACK FOOTER //
// ./src/containers/profecomments/ProfCardContainer.js